import * as React from "react";
import AppBar from "@mui/material/AppBar";
import theme from "@/theme";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";

export const Header = (props = {}) => {
  return (
    <Box sx={{ flexGrow: 1, textAlign: "center", position: "relative" }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: theme.palette.primary.main,
          height: "180px",
        }}
      >
        <CardMedia
          component="img"
          height="180px"
          image="/assets/images/logo-mira.svg"
          alt="Mira"
          sx={{
            width: "200px",
            margin: "0px auto",
            backgroundSize: "auto",
            objectFit: "contain",
          }}
        />
        <Typography
          variant="span"
          color="inherit"
          component="div"
          sx={{
            position: "relative",
            top: "-15px",
            fontSize: "1rem",
          }}
        >
          Testigos Electorales
        </Typography>
        {props.showLogout && (
          <IconButton
            size="large"
            edge="end"
            onClick={props.onLogout}
            sx={{
              color: "white",
              position: "absolute",
              top: "30px",
              right: "15px",
            }}
          >
            <LogoutIcon />
          </IconButton>
        )}
      </AppBar>
    </Box>
  );
};
